import React, { useState } from "react";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { loginUser } from '../services/Login_service';
import '../css/login.css';
import logo from '../image/logo_alo.png';
import test1 from '../image/image.gif';
import img1 from '../image/AloLogo/logo2.png';
import img2 from '../image/AloLogo/logo3.png';
import img3 from '../image/AloLogo/logo4.png';
import img4 from '../image/AloLogo/logo5.png';
import img5 from '../image/AloLogo/logo7.png';
import img6 from '../image/AloLogo/logo10.png';
import img7 from '../image/AloLogo/logo15.png';
import img8 from '../image/AloLogo/logo16.png';
import img9 from '../image/AloLogo/logo18.png';
import img10 from '../image/AloLogo/logo19.png';
import img11 from '../image/AloLogo/logo20.png';
import img12 from '../image/AloLogo/logo21.png';
import img13 from '../image/AloLogo/logo22.png';
import img14 from '../image/AloLogo/logo23.png';
import img15 from '../image/AloLogo/logo24.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from 'react-router-dom';
import { useForm, SubmitHandler } from "react-hook-form";
import { faLock, faEye, faEyeSlash, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faNewspaper, faGaugeHigh } from '@fortawesome/free-solid-svg-icons';
import { FaArrowRight } from "react-icons/fa";

type Inputs = {
    email: string;
    password: string;
};

const Login: React.FC = () => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm<Inputs>();
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [inactiveError, setInactiveError] = useState<boolean>(false);
    const [notVerifiedError, setNotVerifiedError] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const onSubmit: SubmitHandler<Inputs> = async (data: Inputs) => {
        try {
            setLoading(true);
            localStorage.clear();
            const user = await loginUser(data.email, data.password);

            // console.log("onSubmit ", user);

            // Si admin -> home
            if (user && user.role === "ADMIN") {
                navigate("/home");
                return;
            }

            if (user && (user.already_connected || (user as any).first_login_skipped)) {
                navigate("/home");
                return;
            }

            navigate("/verify-code");
        } catch (error: any) {
            if (error?.code === "EMAIL_NOT_VERIFIED") {
                setNotVerifiedError(true);
                setInactiveError(false);
            } else if (error?.code === "USER_INACTIVE") {
                setInactiveError(true);
                setNotVerifiedError(false);
            } else {
                setErrorMessage(error?.message || "Une erreur est survenue lors de la connexion.");
            }
        } finally {
            setLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleRetryLogin = () => {
        // Réaffiche le formulaire et réinitialise les champs
        reset();
        setInactiveError(false);
        setNotVerifiedError(false);
    };

    return (
        <>
            <div className="degrade-vertical big-height">
                {/* logo */}
                <div className="row col-section d-flex justify-content-center align-items-center flex-mobile-reverse">
                    <div className="col-12 col-md-6 col-lg-6 d-flex section-txt mt-5">
                        <div className="bg-section section-tab">
                            <div className="img-animate">
                                <img src={test1} alt="png" className="img-fluid w-75 mb-3 ImgGif" />
                            </div>
                            <div className="row">
                                <div className="col-md-8 justify-content-center align-items-center">
                                </div>
                            </div>
                            <div className="text-title mt-3">
                                <h1 className="font-1 mt-3 title-login">Annonce Legale Officielle</h1>
                                <p className="font-2">
                                    Bénéficiez d’une publication instantanée dans toute la France,
                                    grâce à notre plateforme sécurisée en ligne, disponible 24/7 et adaptée à tout type
                                    d’annonce, des plus simples aux plus complexes.
                                </p>
                                <div className="subtile-item mt-3 d-flex">
                                    <div className="text-subtitle-icon fs-4">
                                        <FontAwesomeIcon icon={faNewspaper} aria-hidden="true" />
                                    </div>
                                    <div className="text ms-3">
                                        <h3 className="fs-5 text-subtitle">Choix du journal</h3>
                                        <p className="font-2 fonts">Vous souhaitez choisir votre support de publication ?
                                            Notre outil vous offre le plus large choix de journaux digitaux et papier
                                            habilités en France.</p>
                                    </div>
                                </div>
                                <div className="subtile-item mt-3 d-flex">
                                    <div className="text-subtitle-icon fs-4">
                                        <FontAwesomeIcon icon={faGaugeHigh} aria-hidden="true" />
                                    </div>
                                    <div className="text ms-3">
                                        <h3 className="fs-5 text-subtitle">Attestation immédiate</h3>
                                        <p className="font-2 fonts">Quelle que soit l'urgence de votre dossier, en utilisant
                                            notre solution, l'attestation de publication est disponible immédiatement
                                            avec le choix sur la méthode de facturation.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-6 d-flex bg-dark-login section-txt">
                        <div className="p-3 logo">
                            <a
                                href="http://annonce-legale-officielle.fr/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src={logo} className="my-2 ml-3 logo-1" alt="logo" />
                            </a>
                        </div>

                        {inactiveError ? (
                            <div className="form-login pb-4 mx-5 px-5 pt-4 col-8">
                                <p className="fs-6">
                                    Votre compte a été désactivé temporairement.
                                </p>

                                <p className="fs-6">
                                    Pour réactiver votre compte ou obtenir de l'aide, veuillez contacter notre service support.
                                </p>

                                <div className="d-flex gap-2 mt-3 justify-content-center">
                                    <a
                                        className="btn btn-outline-secondary"
                                        href="mailto:service-clients@annonce-legale-officielle.fr"
                                        aria-label="Contacter le service support"
                                    >
                                        Contacter le support
                                    </a>

                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleRetryLogin}
                                        disabled={loading}
                                        aria-label="Se connecter à nouveau"
                                    >
                                        Se connecter
                                    </button>
                                </div>

                                <div className="mt-3 d-flex justify-content-center">
                                    <p className="fs-6">
                                        Voir
                                        <a
                                            href="https://annonce-legale-officielle.fr/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="txt-orange mx-1"
                                        >
                                            Annonce Légale Officielle
                                            <span className="arrowIcon">
                                                <FaArrowRight style={{ marginTop: '1rem' }} />
                                            </span>
                                        </a>
                                    </p>
                                </div>
                            </div>

                        ) : notVerifiedError ? (
                            <div className="form-login pb-4 mx-5 px-5 pt-4 col-8">
                                <p className="fs-6">
                                    Votre compte n'est pas encore activé.
                                </p>

                                <p className="fs-6">
                                    Pour activer votre compte, veuillez cliquer sur le lien de confirmation
                                    qui vous a été envoyé par email lors de votre inscription.
                                </p>

                                <p className="fs-6">
                                    Si vous ne trouvez pas cet email, pensez à vérifier votre dossier
                                    <strong> courriers indésirables</strong> ou contactez notre service support.
                                </p>

                                <div className="d-flex gap-2 mt-3 justify-content-center">
                                    <a
                                        className="btn btn-outline-secondary"
                                        href="mailto:service-clients@annonce-legale-officielle.fr"
                                        aria-label="Contacter le service support"
                                    >
                                        Contacter le support
                                    </a>

                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleRetryLogin}
                                        disabled={loading}
                                        aria-label="Se connecter à nouveau"
                                    >
                                        Se connecter
                                    </button>
                                </div>

                                <div className="mt-3 d-flex justify-content-center">
                                    <p className="fs-6">
                                        Voir
                                        <a
                                            href="https://annonce-legale-officielle.fr/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="txt-orange mx-1"
                                        >
                                            Annonce Légale Officielle
                                            <span className="arrowIcon">
                                                <FaArrowRight style={{ marginTop: '1rem' }} />
                                            </span>
                                        </a>
                                    </p>
                                </div>
                            </div>

                        ) : (
                            <form className="form-login pb-4 mx-5 px-5 pt-4 col-8 d-flex" onSubmit={handleSubmit(onSubmit)}>
                                <p className="txt-login mb-4">Se connecter</p>

                                <div className="col-md-13 col-12">
                                    <div className="input-group mb-3">
                                        <span className="input-group-text" id="basic-addon1">
                                            <FontAwesomeIcon icon={faEnvelope} />
                                        </span>
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="email"
                                            {...register('email', {
                                                required: 'Email est requis'
                                            })}
                                        />
                                    </div>
                                    {errors.email && <p className="error-message">{errors.email.message}</p>}
                                </div>

                                <div className="col-md-13 col-12">
                                    <div className="input-group">
                                        <span className="input-group-text" id="basic-addon1">
                                            <FontAwesomeIcon icon={faLock} />
                                        </span>
                                        <input
                                            className="form-control"
                                            type={showPassword ? "text" : "password"}
                                            placeholder="mot de passe"
                                            {...register('password', { required: 'Mot de passe est requis' })}
                                        />
                                        <button
                                            className="btn btn-outline-secondary"
                                            type='button'
                                            onClick={togglePasswordVisibility}
                                            aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                                        >
                                            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                        </button>
                                    </div>
                                    {errors.password && <p className="error-message">{errors.password.message}</p>}
                                </div>

                                <div className="mb-2 mt-2 d-flex" style={{ justifyContent: 'flex-end', fontSize: '0.9em', textDecoration: 'none' }}>
                                    <Link to="/mail" className=""><span style={{ fontSize: '1.1em' }}>Mot de passe oublié ?</span></Link>
                                </div>

                                {errorMessage && (
                                    <div className="alert alert-danger">
                                        {errorMessage}
                                    </div>
                                )}


                                <button type="submit" className="btn btn-1" disabled={loading}>
                                    {loading ? "Chargement..." : "Se connecter"}
                                </button>

                                <div className="my-3">
                                    <p>Vous n'avez pas encore de compte ?
                                        <Link to="/register" className="txt-orange mx-1">S'inscrire</Link>
                                    </p>
                                </div>

                                <div className="myLink">
                                    <p className="fs-6"> Voir
                                        <a
                                            href="https://annonce-legale-officielle.fr/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="txt-orange mx-1"
                                        >
                                            Annonce Legale Officielle
                                            <span className="arrowIcon">
                                                <FaArrowRight />
                                            </span>
                                        </a>
                                    </p>
                                </div>
                            </form>
                        )}

                        {/* logos grid */}
                        <div className="grid text-center mt-3">
                            <div><img src={img1} alt="png" className="img-fluid w-75" /></div>
                            <div><img src={img2} alt="png" className="img-fluid w-75" /></div>
                            <div><img src={img3} alt="png" className="img-fluid w-75" /></div>
                            <div><img src={img4} alt="png" className="img-fluid w-75" /></div>
                            <div><img src={img5} alt="png" className="img-fluid w-75" /></div>
                        </div>

                        <div className="grid text-center">
                            <div><img src={img6} alt="png" className="img-fluid w-75" /></div>
                            <div><img src={img7} alt="png" className="img-fluid w-75" /></div>
                            <div><img src={img8} alt="png" className="img-fluid w-75" /></div>
                            <div><img src={img9} alt="png" className="img-fluid w-75" /></div>
                            <div><img src={img10} alt="png" className="img-fluid w-75" /></div>
                        </div>

                        <div className="grid text-center">
                            <div><img src={img11} alt="png" className="img-fluid w-75" /></div>
                            <div><img src={img12} alt="png" className="img-fluid w-75" /></div>
                            <div><img src={img13} alt="png" className="img-fluid w-75" /></div>
                            <div><img src={img14} alt="png" className="img-fluid w-75" /></div>
                            <div><img src={img15} alt="png" className="img-fluid w-75" /></div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;
